/**
 * 임베드(판매자 센터·알림톡 링크) 화면의 인증 오류를 사용자가 읽을 안내로 바꾼다.
 *
 * 공용 훅이 내는 «토큰이 제공되지 않았습니다.»·«유효하지 않은 토큰입니다» 같은 내부 문구가 그대로
 * 화면에 나왔고(A3-28), 다시 시도해도 같은 화면이라 빠져나갈 길이 없었다. 원인별로 무엇을 하면
 * 되는지 알려 주고, 다시 시도가 소용없는 경우에는 그 버튼을 감춘다.
 */
export interface EmbedAuthNotice {
  title: string;
  message: string;
  /** 다시 시도로 풀릴 수 있는 오류인가(네트워크 등). 링크 문제면 false. */
  retryable: boolean;
}

export const EMBED_SESSION_EXPIRED_NOTICE: EmbedAuthNotice = {
  title: "로그인이 만료되었습니다",
  message:
    "보안을 위해 일정 시간이 지나면 다시 로그인해야 합니다. 판매자 대시보드나 씨마켓에서 이 화면을 다시 열어주세요.",
  retryable: false,
};

export function toEmbedAuthNotice(error: string): EmbedAuthNotice {
  if (error.includes("토큰이 제공되지")) {
    return {
      title: "접속 정보가 없습니다",
      message:
        "이 화면은 판매자 대시보드나 씨마켓·알림톡 링크로 열어야 합니다. 받은 링크로 다시 들어오거나 로그인해주세요.",
      retryable: false,
    };
  }
  if (error.includes("만료")) {
    return {
      title: "링크가 만료되었습니다",
      message:
        "보안을 위해 링크는 잠시만 쓸 수 있습니다. 판매자 대시보드나 씨마켓에서 이 화면을 다시 열어주세요.",
      retryable: false,
    };
  }
  if (error.includes("유효하지 않은") || error.includes("잘못된")) {
    return {
      title: "링크를 열 수 없습니다",
      message:
        "링크가 올바르지 않거나 이미 사용되었습니다. 판매자 대시보드나 씨마켓에서 이 화면을 다시 열어주세요.",
      retryable: false,
    };
  }
  return { title: "접근 오류", message: error, retryable: true };
}
